
import React from 'react';
import { Link } from 'react-router-dom';
import { HelpCircle, BookOpen, Image, Sparkles } from 'lucide-react';
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from "@/components/ui/tooltip";

const Header = () => {
  return (
    <header className="py-6 border-b border-gray-200">
      <div className="container mx-auto px-4 flex justify-between items-center">
        <div className="flex items-center gap-6">
          <Link 
            to="/" 
            className="flex items-center gap-2 hover:opacity-90 transition-opacity"
          >
            <img 
              src={`${import.meta.env.BASE_URL}lovable-uploads/4206a798-4c21-45ef-a749-16bb1bc65611.png`}
              alt="DIY Book Covers Logo" 
              className="h-10 w-auto"
            />
          </Link>
          
          <nav className="hidden md:flex items-center gap-4">
            <Link 
              to="/" 
              className="flex items-center gap-2 text-bookGray hover:text-bookNavy transition-colors font-medium"
            >
              <BookOpen className="w-4 h-4" />
              Cover Critic
            </Link>
            <Link 
              to="/gallery" 
              className="flex items-center gap-2 text-bookGray hover:text-bookNavy transition-colors font-medium"
            >
              <Image className="w-4 h-4" />
              Gallery
            </Link>
            <a 
              href="https://diybookcovers.com/covermaker" 
              target="_blank"
              rel="noopener noreferrer"
              className="flex items-center gap-2 text-bookGray hover:text-bookNavy transition-colors font-medium"
            >
              <Sparkles className="w-4 h-4" />
              Cover Maker
            </a>
          </nav>
        </div>
        
        <div className="flex items-center gap-4">
          <div className="hidden lg:block text-sm text-bookGray">
            Honest feedback on your book cover design
          </div>
          <div>
            <TooltipProvider>
              <Tooltip>
                <TooltipTrigger asChild>
                  <Link to="/help" className="text-bookGray hover:text-bookNavy transition-colors">
                    <HelpCircle className="w-6 h-6" />
                  </Link>
                </TooltipTrigger>
                <TooltipContent>
                  <p>Help & FAQ</p>
                </TooltipContent>
              </Tooltip>
            </TooltipProvider>
          </div>
        </div>
      </div>
    </header>
  );
};

export default Header;
